import antdJa from "antd/lib/locale-provider/ja_JP";
import appLocaleData from "react-intl/locale-data/ja";
import enMessages from "../locales/en_US.json";
import jaMessages from "../locales/ja_JP.json";

const JaLang = {
  messages: {
    ...enMessages,
    ...jaMessages
  },
  antd: antdJa,
  locale: 'ja',
  data: appLocaleData
};
export default JaLang;
